import React, { useState, useEffect, useRef } from 'react';
import { FaPencilAlt, FaArrowLeft, FaDownload, FaTrash } from "react-icons/fa";

export default function ActionsDropdown({ isOpen, onClose, dropdownRef, onDeleteClick, onRenameClick, onDownloadClick, onRemovePublishableClick, fileOrigin, isPublished, buttonRef }) {
    const [position, setPosition] = useState({ top: 0, right: 0 });
    const dropdownRefInternal = useRef(null);

    useEffect(() => {
        if (isOpen && buttonRef) {
            const updatePosition = () => {
                const rect = buttonRef.getBoundingClientRect();
                const dropdownHeight = dropdownRefInternal.current?.offsetHeight || 200;
                const spaceBelow = window.innerHeight - rect.bottom;
                const spaceAbove = rect.top;
                const shouldFlipUp = spaceBelow < dropdownHeight && spaceAbove > spaceBelow;

                if (shouldFlipUp) {
                    setPosition({
                        top: rect.top - dropdownHeight - 4,
                        right: window.innerWidth - rect.right
                    });
                } else {
                    setPosition({
                        top: rect.bottom + 4,
                        right: window.innerWidth - rect.right
                    });
                }
            };

            updatePosition();
            // Use a small delay to ensure dropdown is rendered and has height
            const timeoutId = setTimeout(updatePosition, 0);
            window.addEventListener('scroll', updatePosition, true);
            window.addEventListener('resize', updatePosition);

            return () => {
                clearTimeout(timeoutId);
                window.removeEventListener('scroll', updatePosition, true);
                window.removeEventListener('resize', updatePosition);
            };
        }
    }, [isOpen, buttonRef]);

    if (!isOpen) return null;

    const styles = {
        dropdownMenu: {
            position: 'fixed',
            top: `${position.top}px`,
            right: `${position.right}px`,
            backgroundColor: '#27272A',
            border: '1px solid #4A5568',
            borderRadius: '8px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            zIndex: 10000,
            minWidth: '200px',
            padding: '8px 0',
        },
        dropdownItem: {
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            padding: '12px 16px',
            color: 'white',
            cursor: 'pointer',
            transition: 'background-color 0.2s',
            border: 'none',
            backgroundColor: 'transparent',
            width: '100%',
            textAlign: 'left',
            fontSize: '14px',
        },
        dropdownItemHover: {
            backgroundColor: '#4A5568',
        },
        deleteItem: {
            color: '#F56565',
        }
    };

    const handleDownload = () => {
        onDownloadClick();
        onClose();
    };

    const handleDelete = (e) => {
        e.stopPropagation();
        onDeleteClick();
    }    

    return (
        <>
            <div style={styles.dropdownMenu} ref={(el) => { dropdownRefInternal.current = el; if (dropdownRef) dropdownRef.current = el; }}>
            <button 
                style={styles.dropdownItem}
                onMouseEnter={(e) => e.target.style.backgroundColor = styles.dropdownItemHover.backgroundColor}
                onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                onClick={(e) => {
                    e.stopPropagation();
                    onRenameClick();
                }}
            >
                <FaPencilAlt />
                Renomear
            </button>

            {isPublished && (
                    <button 
                        style={styles.dropdownItem}
                        onMouseEnter={(e) => e.target.style.backgroundColor = styles.dropdownItemHover.backgroundColor}
                        onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                        onClick={onRemovePublishableClick}
                    >
                        <FaArrowLeft />
                        Remover de publicados
                    </button>
            )}
            
            <button 
                style={styles.dropdownItem}
                onMouseEnter={(e) => e.target.style.backgroundColor = styles.dropdownItemHover.backgroundColor}
                onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                onClick={handleDownload}
            >
                <FaDownload />
                Download
            </button>
            
            <button 
                style={{...styles.dropdownItem, ...styles.deleteItem}}
                onMouseEnter={(e) => e.target.style.backgroundColor = styles.dropdownItemHover.backgroundColor}
                onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                onClick={(e) => handleDelete(e)}
            >
                <FaTrash />
                Apagar
            </button>
        </div>
        </>
    );
};
